import { useEffect, useState } from 'react';
import { config } from '../utils/config';

const Home = () => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');
  const staticUrl = config.staticUrl;

  useEffect(() => {
    // Load static content from static subdomain
    fetch(`${staticUrl}/home.html`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load content: ${response.status}`);
        }
        return response.text();
      })
      .then(data => {
        setContent(data.replaceAll('{{STATIC_URL}}', staticUrl));
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading home content:', err);
        setError(err.message);
        setLoading(false);
      });
  }, [staticUrl]);

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="ui active inline loader"></div>
        <p className="text-gray-600 mt-4">Loading content...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="text-red-600 mb-4">
          <h2 className="text-2xl font-bold mb-2">Error Loading Content</h2>
          <p>{error}</p>
        </div>
        <p className="text-sm text-gray-500">
          Make sure the static content is available at: <code className="bg-gray-100 px-2 py-1 rounded">{staticUrl}/home.html</code>
        </p>
      </div>
    );
  }

  return (
    <div dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default Home;
